import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { toast } from "sonner";
import { useUpdateCustomerPostsConfigAPI } from "../../../../features/fans/settings/settings.api";

type Props = {
  onClose: () => void;
  identityId: string;
  currentAdditionalPosts: number;
};

export default function AddSocialPostsDialog({ onClose, identityId, currentAdditionalPosts }: Props) {
  const [additionalPosts, setAdditionalPosts] = useState<string>(currentAdditionalPosts.toString());
  const { mutate: updatePosts, isLoading } = useUpdateCustomerPostsConfigAPI();

  const handleSubmit = () => {
    const num = parseInt(additionalPosts, 10);
    if (!isNaN(num)) {
      updatePosts(
        { identityId, additionalPosts: num },
        {
          onSuccess: () => {
            toast.success("Additional social posts updated successfully");
            onClose();
          },
          onError: () => {
            toast.error("Failed to update social posts");
          }
        }
      );
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) setAdditionalPosts(value);
  };

  return (
    <Dialog open={true} maxWidth="sm" onClose={onClose}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Edit Additional Social Posts
          <IconButton aria-label="close" onClick={onClose}><CloseIcon /></IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Box sx={{ mt: 1, mb: 0 }}>
          <Typography variant="body1" sx={{ mb: 2 }} gutterBottom>
            Set the total number of additional social posts for this user:
          </Typography>
          <TextField
            fullWidth
            label="Additional Social Posts"
            value={additionalPosts}
            onChange={handleChange}
            type="text"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ pr: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isLoading} variant="outlined">Cancel</Button>
        <Button onClick={handleSubmit} disabled={isLoading} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}
